import React from 'react';

import {createLinkComponent, LinkToPropType} from '@tager/web-components';

export const linkConverter = (link: LinkToPropType) => link;

const TagerLink = createLinkComponent({converter: linkConverter});

const Link = (props: any) => <TagerLink {...props} />

export default Link;
